import Login from 'containers/authComponents/Login';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { stateIsLoaded } from '@guryou/redux';

const LoginPage = () => {
  const auth = useSelector(state => state.auth);
  const location = useLocation();

  if (stateIsLoaded(auth) && auth?.data?.userId) {
    const from = location.state?.from || { pathname: '/' };
    return <Redirect to={from} />;
  }

  return (
    <div className="flex h-screen justify-center pt-20">
      <Login hideRegister={true} hideForgotPassword={true} />
    </div>
  );
};

export default LoginPage;
